import { DlpOrderRequest, DlpSecondaryOrderResponse } from 'apiConnector/secondary-market/dlpOrder/model';
import { NextWorkflowError } from 'models/NextWorkflowError';

export type SecondaryMarketDlpOrderOrderActions = SecondaryMarketDlpOrderPlacementActions;

type SecondaryMarketDlpOrderPlacementActions =
  | SecondaryMarketDlpOrderPlacementRequested
  | SecondaryMarketDlpOrderPlacementReceived
  | SecondaryMarketDlpOrderPlacementFailed
  | SecondaryMarketDlpOrderPlacementClose
  | SecondaryMarketDlpOrderPlacementStale;

/////////////////////////////////////////////
export function secondaryMarketDlpOrderPlacementRequested(tabId: string, request: DlpOrderRequest) {
  return {
    type: 'SECONDARY_MARKET_DLP_ORDER_PLACEMENT_REQUESTED' as const,
    tabId,
    request,
  };
}

export type SecondaryMarketDlpOrderPlacementRequested = ReturnType<typeof secondaryMarketDlpOrderPlacementRequested>;

/////////////////////////////////////////////

export function secondaryMarketDlpOrderPlacementReceived(tabId: string, data: DlpSecondaryOrderResponse) {
  return {
    type: 'SECONDARY_MARKET_DLP_ORDER_PLACEMENT_RECEIVED' as const,
    tabId,
    ...data,
  };
}
export type SecondaryMarketDlpOrderPlacementReceived = ReturnType<typeof secondaryMarketDlpOrderPlacementReceived>;
/////////////////////////////////////////////

export function secondaryMarketDlpOrderPlacementStale(tabId: string) {
  return {
    type: 'SECONDARY_MARKET_DLP_ORDER_PLACEMENT_STALE' as const,
    tabId,
  };
}
export type SecondaryMarketDlpOrderPlacementStale = ReturnType<typeof secondaryMarketDlpOrderPlacementStale>;
/////////////////////////////////////////////

export function secondaryMarketDlpOrderPlacementFailed(
  tabId: string,
  isTimeout: boolean,
  errorMessage?: string,
  timeout?: number,
  rejections?: readonly NextWorkflowError[],
  orderId?: string,
) {
  return {
    type: 'SECONDARY_MARKET_DLP_ORDER_PLACEMENT_FAILED' as const,
    tabId,
    isTimeout,
    errorMessage,
    timeout,
    rejections,
    orderId,
  };
}

export type SecondaryMarketDlpOrderPlacementFailed = ReturnType<typeof secondaryMarketDlpOrderPlacementFailed>;

/////////////////////////////////////////////

export function secondaryMarketDlpOrderPlacementClose(tabId: string) {
  return {
    type: 'SECONDARY_MARKET_DLP_ORDER_CLOSE' as const,
    tabId,
  };
}

export type SecondaryMarketDlpOrderPlacementClose = ReturnType<typeof secondaryMarketDlpOrderPlacementClose>;
